import { http, HttpResponse } from 'msw';
import { PlessService } from '../../app/shared/pless-service.model';
import { HttpHeaders } from '@angular/common/http';
import { ResponseUtils } from './response-utils';

export const kymwHandlers = [
    // ログアウト /logout
    http.post(PlessService.SERVICE.Logout.url,
        async ({ request }) => {
            const req = await request.json();
            return HttpResponse.json(getResultList);
            // return ResponseUtils.getSysError();
            // return ResponseUtils.getSysE0100();
            // return ResponseUtils.getSys500();
        }
    ),
];

const getResultList = {
    status: "ok",
    message: "処理完了",
    result: {
        obj: {}
    }
}